// extracted by css-extract-rspack-plugin
export default {"root":"CardHeader_root__hEhwP","title":"CardHeader_title__zBNEz","content":"CardHeader_content__kRqrV"};